<template>
  <v-app>
    <v-main class="landingpage">
      <section>
        <div class="globe-header landing-v4-hero">
          <v-layout
            column
            align-center
            justify-center
            class="white--text bg-gradient fill-height overflow-hidden"
          >
            <!-- <iframe src="/globe/index.html" class="iframe-globe" title="Self Biography Globe" frameborder="0" allowtransparency="true"></iframe> -->

            <video
              width="100%"
              height="100%"
              muted
              autoplay
              loop
              playsinline
            >
              <source
                :src="require('@/assets/images/pages/landingpage/globe.mp4')"
                type="video/mp4"
              >{{ $t("\n              Your browser does not support the video tag.\n            ") }}</video>

            <div class="globe-text">
              <div class="wrapper-logo">
                <img :src="require('@/assets/images/logos/selfbio-logo-6.png')" />
                <h2
                  class="app-title text--primary"
                  style="color: #fff !important"
                >
                  <span style="color: #9155fd;">SELF</span>BIOGRAPHY
                </h2>
              </div>
              <h1 class="white--text mb-2 display-1 text-xs-center txt-title-header">
                {{ $t("\n                Record Your Life. Tell Your Story. Leave Your Mark.\n              ") }}
              </h1>
              <div class="white--text subheading mb-3 text-xs-center txt-subtitle">
                {{ $t("\n                Everyone has a story worth preserving - for themselves, the people they love, and generations still to come.\n              ") }}
              </div>
            </div>
          </v-layout>
          <div class="landing-v4-hero-actions">
            <div class="white--text subheading mb-3 text-xs-center txt-why-not">
              {{ $t("\n              Every memory is a piece. Your life is the puzzle.\n            ") }}
            </div>
            <div class="landing-v4-button-row">
              <v-btn
                class="blue lighten-2 mt-2"
                dark
                large
                href="/auth"
              >
                {{ $t("\n                JOIN FREE\n              ") }}
              </v-btn>
              <v-btn
                class="blue lighten-2 mt-2"
                dark
                large
                href="/pages/pricing#choose-plan"
              >
                {{ $t("\n                SUBSCRIBE\n              ") }}
              </v-btn>
              <v-btn
                class="blue lighten-2 mt-2"
                dark
                large
                href="/pages/affiliate-program"
              >
                {{ $t("\n                EARN\n              ") }}
              </v-btn>
            </div>
          </div>
        </div>
      </section>
      <section>
        <v-layout
          column
          wrap
          class="mt-10"
          align-center
        >
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout
                row
                wrap
                align-center
              >
                <div class="section">
                  <div class="container">
                    <div class="perspective-phone">
                      <h2 class="headline text-center">
                        {{ $t("\n                        Anytime, anywhere.") }}<br />{{ $t("\n                        All in one place, organized chronologically and just one click away on any device.\n                      ") }}
                      </h2>
                      <img
                        :src="require('@/assets/images/pages/landing-laptop.webp')"
                        :alt="$t(&quot;Perspective computer&quot;)"
                        style="position:relative;top:-38px;"
                      >
                    </div>
                    <div
                      class="row"
                      style="position:relative;top:-60px;"
                    >
                      <div class="col-12 col-lg-4">
                        <div class="card features">
                          <div class="card-body">
                            <div class="media">
                              <span class="ti-face-smile gradient-fill ti-3x mr-3"></span>
                              <div class="media-body">
                                <h4 class="card-title">
                                  {{ $t("\n                                  Simple and Easy to Use\n                                ") }}
                                </h4>
                                <p class="card-text mt-2">
                                  {{ $t("\n                                  Self Biography is designed to make recording your life as natural as living it. Capture memories as they happen, add a quick thought or story, or bring in photos, videos, and other media from your phone or computer. Photo Scan for your old albums is coming soon. No need to worry about file formats, image sizes, or technical details - SB automatically organizes and optimizes your content so you can concentrate on the memory, not the technology.\n                                ") }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-4">
                        <div class="card features">
                          <div class="card-body">
                            <div class="media">
                              <span class="ti-settings gradient-fill ti-3x mr-3"></span>
                              <div class="media-body">
                                <h4 class="card-title">
                                  {{ $t("\n                                  Customizable\n                                ") }}
                                </h4>
                                <p class="card-text mt-2">
                                  {{ $t("\n                                  It is your life, so you decide how to tell it. Use Self Biography’s standard categories, edit them, or create your own. Organize memories by people, places, family, friends, travels, accomplishments, interests, or anything meaningful to you. Edit and expand your memories at any time, and decide what remains private, what you share, and what eventually becomes part of your published biography.\n                                ") }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-4">
                        <div class="card features">
                          <div class="card-body">
                            <div class="media">
                              <span class="ti-lock gradient-fill ti-3x mr-3"></span>
                              <div class="media-body">
                                <h4 class="card-title">
                                  {{ $t("\n                                  Private and Secure\n                                ") }}
                                </h4>
                                <p class="card-text mt-2">
                                  {{ $t("\n                                  You are always the gatekeeper. Self Biography is privacy-centric and designed to protect your personal life archive. You decide what remains private, what you share with family and friends, and what you choose to make public. Your memories, your information, your decision.\n                                ") }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section
        class="landing-v4-stories"
        :aria-label="$t(&quot;Discover Self Biography&quot;)"
      >
        <v-img
          :src="require('@/assets/images/pages/landingpage/3.webp')"
          class="landing-v4-stories-background"
          aria-hidden="true"
        ></v-img>
        <v-carousel
          cycle
          :show-arrows="$vuetify.breakpoint.mdAndUp"
          :interval="$vuetify.breakpoint.smAndDown ? 90000 : 60000"
          height="auto"
        >
          <v-carousel-item
            v-for="story in stories"
            :key="story.id"
          >
            <div class="landing-v4-story-stage">
              <div class="headline white--text mb-3 text-xs-center txt-typing landing-v4-story-copy">
                {{ story.text }}<strong v-if="story.emphasis">{{ story.emphasis }}</strong>{{ story.after }}
              </div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </section>
      <section class="landingpage">
        <v-container grid-list-md>
          <h2 class="headline text-center ma-10">
            {{ $t("\n            Everything in one place in chronological order\n          ") }}
          </h2>
          <v-layout
            row
            wrap
          >
            <v-flex>
              <v-card class="elevation-0 transparent">
                <v-card-text>
                  <v-timeline
                    align-top
                    :dense="$vuetify.breakpoint.smAndDown"
                  >
                    <v-timeline-item
                      v-for="(item, i) in items"
                      :key="i"
                      :color="item.color"
                      :icon="item.icon"
                      fill-dot
                    >
                      <v-card
                        :color="item.color"
                        dark
                      >
                        <v-card-title class="text-h6">
                          {{ item.title }}
                        </v-card-title>
                        <v-card-text class="white text--primary">
                          <p class="pt-5">
                            {{ item.text }}
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>

                  <details class="landing-v4-planned">
                    <summary class="primary--text">
                      {{ $t("\n                      Coming soon & future development\n                    ") }}
                    </summary>
                    <h2
                      id="landing-v4-planned-title"
                      class="headline primary--text my-6"
                    >
                      {{ $t("\n                      More chapters are still to come.\n                    ") }}
                    </h2>
                    <v-card class="elevation-0 transparent">
                      <v-card-text>
                        <p class="subheading mb-3 txt-subtitle">
                          {{ $t("\n                          The following ideas are in development or part of our future vision. They are separate from the features and subscription benefits available today.\n                        ") }}
                        </p>
                        <v-timeline
                          align-top
                          :dense="$vuetify.breakpoint.smAndDown"
                        >
                          <v-timeline-item
                            v-for="feature in plannedItems"
                            :key="feature.title"
                            :icon="feature.icon"
                            fill-dot
                          >
                            <v-card dark>
                              <v-card-title class="text-h6 px-4">
                                {{ feature.title }}
                              </v-card-title>
                              <div class="px-5 pb-4">
                                <v-chip
                                  small
                                  outlined
                                  dark
                                >
                                  {{ $t("\n                                  Coming soon\n                                ") }}
                                </v-chip>
                              </div>
                              <v-card-text
                                class="text--primary"
                                :class="{ white: !$vuetify.theme.dark }"
                              >
                                <p class="pt-5">
                                  {{ feature.text }}
                                </p>
                              </v-card-text>
                            </v-card>
                          </v-timeline-item>
                        </v-timeline>
                      </v-card-text>
                    </v-card>
                  </details>

                  <h2
                    class="headline text-center pt-15"
                    :style="{ color: $vuetify.theme.dark ? '#c8afff !important' : '#633991 !important' }"
                  >
                    {{ $t("\n                    Self Biography is not Facebook.\n                  ") }}
                  </h2>
                  <div class="subheading mb-3 text-xs-center txt-subtitle text-justify">
                    {{ $t("\n                    Self Biography is not another social media network. It is a network of private networks built around people, families, friends, and the memories they share. There is no public newsfeed designed to keep everyone arguing, no opinion-driven commentary, and no political discourse. Instead, Self Biography gives us a place to preserve and rediscover the stories, knowledge, culture, accomplishments, and wisdom that are being lost with every generation. The idea is simple: bring people together through their shared memories rather than keep them apart by their opinions.\n                  ") }}
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
      <section class="section-carrousel">
        <v-carousel
          cycle
          :height="imgHeight"
        >
          <v-carousel-item
            v-for="([slide, text], i) in slides"
            :key="i"
            :src="require(`@/assets/images/pages/landingpage/${ slide }`)"
            color="#000000"
          >
            <h5 class="white--text mb-2 display-1 text-xs-center">
              {{ $t(text) }}
            </h5>
          </v-carousel-item>
        </v-carousel>
      </section>
    </v-main>
  </v-app>
</template>

<script>
import { mdiStar } from '@mdi/js'
import { t, localizeCopy } from '@/i18n'

import content from '@/content/landingPageContentV3.json'

export default {
  name: 'LandingPageV4',
  components: {},
  data() {
    return {
      stories: [
        {
          id: 'preserve',
          get text() { return t('The first of its kind, Self Biography is an archival private social media platform where you can document your life and publish an official biographical record that will be preserved for future generations. You can record memories and life accomplishments using any form of media, which will be organized chronologically into a timeline. Self Biography is privacy-centric, data-secure, and you are always the “gatekeeper” of the information that you put in.') },
        },
        {
          id: 'affiliate',
          get text() { return t('Self Biography is also designed to reward the people who help build its community. Become a Self Biography Affiliate and invite friends, family, colleagues, creators, or your own audience to preserve their stories. When someone you introduce becomes a paying subscriber, you can earn a ') },
          get emphasis() { return t('25% affiliate commission') },
          after: '. By helping Self Biography grow one life, one family, and one connection at a time, you can create an ongoing source of income while helping build a worldwide archive of human lives and memories.',
        },
        {
          id: 'professional',
          get emphasis() { return t("Your life and your life's work belong together.") },
          get after() { return t(" Switch between Personal and Professional views to tell the story of who you are and what you have accomplished. Build a professional timeline and portfolio of your career, artwork, projects, publications, businesses, awards, exhibitions, media, and accomplishments - all connected to the memories, people, places, and experiences behind them. Publish your Professional Biography as a portfolio, résumé, career archive, or permanent record of your life's work.") },
        },
      ],
      videoOptions: {
        autoplay: false,
        controls: true,
        sources: [
          {
            src:
              'https://www.youtube.com/embed/IMRJhk-4ik0',
            type: 'youtube',
          },
        ],
      },
      slides: [
        ['2.webp', 'My Memories'],
        ['4.webp', 'My Places'],
        ['8.webp', 'My Diary'],
        ['9.webp', 'My Story'],
        ['7.webp', 'My Things'],
        ['10.webp', 'My Life’s Work'],
        ['11.webp', 'My Food'],
        ['12.webp', 'My Pets'],
        ['13.webp', 'My Thoughts'],
        ['14.webp', 'My Beliefs'],
        ['15.webp', 'My Travels'],
      ],
    }
  },

  computed: {
    items() { return localizeCopy(content.features).map(feature => ({ ...feature, icon: mdiStar })) },
    plannedItems() { return localizeCopy(content.planned).map(feature => ({ ...feature, icon: mdiStar })) },
    imgHeight() {
      return window.innerHeight * 0.70
    },
  },
  methods: {
  },
}
</script>

<style scoped>
.theme--dark .landingpage h2.headline { color: #c8afff !important; }
.theme--dark .perspective-phone h2 { top: 0; }
.theme--dark .perspective-phone img { top: 0 !important; margin-top: 24px; margin-bottom: 88px; border: 1px solid #4a445f; border-radius: 12px; filter: brightness(.85); }
.theme--dark .landingpage .card.features { background-color: #312d4b; border-color: #4a445f; }
.theme--dark .landingpage .card.features .card-title { color: #f0ebff; }
.theme--dark .landingpage .card.features .card-text { color: #ddd8ec; }
.theme--dark .landingpage .v-timeline ::v-deep .v-card__text { background-color: #37324f !important; color: #ddd8ec !important; }
/* Match the tallest overview card, including when the cards stack. */
.perspective-phone + .row { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); grid-auto-rows: 1fr; }
.perspective-phone + .row > .col-12 { max-width: 100%; }
.perspective-phone + .row .card.features { height: 100%; }
@media (max-width: 1263px) {
  .perspective-phone + .row { grid-template-columns: minmax(0, 1fr); }
}
.landing-v4-planned { margin-top: 24px; }
.landing-v4-planned > summary { width: fit-content; padding: 12px 0; cursor: pointer; text-decoration: underline; text-underline-offset: 3px; }
.landing-v4-planned > summary:focus-visible { outline: 2px solid currentColor; outline-offset: 4px; }

.landing-v4-stories { position: relative; overflow: hidden; }
.landing-v4-stories-background { position: absolute; inset: 0; filter: grayscale(1); }
.landing-v4-stories::after { content: ''; position: absolute; inset: 0; z-index: 1; pointer-events: none; background: linear-gradient(rgba(0,0,0,.35), rgba(0,0,0,.35)), linear-gradient(rgba(106,63,185,.5), rgba(106,63,185,.5)); }
.landing-v4-stories > .v-carousel { position: relative; z-index: 2; }
.landing-v4-stories ::v-deep .v-responsive__sizer { padding-bottom: 0 !important; }
.landing-v4-story-stage { display: flex; justify-content: center; align-items: center; min-height: 651px; padding: 64px 0 88px; }
.landing-v4-story-copy { font-size: 1.85rem !important; width: 90%; max-width: 1200px; text-align: justify; font-family: 'Courier' !important; text-shadow: 5px 2px 5px black; font-weight: bold; }
.landing-v4-story-copy strong { font-weight: inherit; }
@media (max-width: 940px) {
  .landing-v4-story-copy { font-size: 1rem !important; }
}

@media (max-width: 600px) {
  .landingpage .v-timeline--dense:not(.v-timeline--reverse)::before {
    left: 32px;
  }

  .v-timeline--dense ::v-deep .v-timeline-item__divider {
    min-width: 64px;
  }

  .v-timeline--dense ::v-deep .v-timeline-item__body {
    max-width: calc(100% - 64px);
  }

}

.landing-v4-hero {
  height: 675px;
  min-height: 675px;
  overflow: hidden;
}

.landing-v4-hero::after {
  width: 100%;
  pointer-events: none;
}

.landing-v4-hero video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  max-height: none;
}

.landing-v4-hero .globe-text {
  top: 43%;
  width: calc(100% - 48px);
}

.landing-v4-hero .txt-subtitle {
  font-size: 22px !important;
  line-height: 33px;
}

.landing-v4-hero .txt-why-not {
  font-size: 25px !important;
  line-height: 37.5px;
}

.landing-v4-hero-actions {
  position: absolute;
  bottom: 30px;
  z-index: 1;
  left: 50%;
  width: calc(100% - 32px);
  transform: translateX(-50%);
}

.landing-v4-button-row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

@media (min-width: 601px) and (max-width: 1000px) {
  .landing-v4-hero .txt-title-header {
    font-size: 32px !important;
    line-height: 40px;
  }

  .landing-v4-hero .txt-subtitle {
    font-size: 18px !important;
    line-height: 27px;
  }
}

@media (max-width: 600px) {
  .landing-v4-hero {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 40px;
    height: auto;
    padding: 48px 16px 30px;
  }

  .landing-v4-hero > .layout {
    flex: none;
    height: auto !important;
  }

  .landing-v4-hero .globe-text {
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    transform: none;
  }

  .landing-v4-hero .wrapper-logo img {
    width: 112px;
    height: 112px;
  }

  .landing-v4-hero .wrapper-logo h2 {
    font-size: 32px !important;
    line-height: 48px;
  }

  .landing-v4-hero .txt-title-header {
    font-size: 28px !important;
    line-height: 34px;
  }

  .landing-v4-hero .txt-subtitle {
    font-size: 16px !important;
    line-height: 24px;
  }

  .landing-v4-hero .txt-why-not {
    font-size: 20px !important;
    line-height: 30px;
  }

  .landing-v4-hero-actions {
    position: relative;
    bottom: auto;
    left: auto;
    width: 100%;
    transform: none;
  }

  .landing-v4-button-row .v-btn {
    padding-right: 16px;
    padding-left: 16px;
  }
}

@media (max-width: 400px) {
  .landing-v4-button-row .v-btn {
    min-width: 0;
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
